<div class="status-item-wrapper">
	<div class="status-item" [routerLink]="itemPath()" [routerLinkActive]="'status-item-active'" [ngClass]="{'status-item-reverse':reverseIcon(), 'status-item-text':!statusItem().icon}">
		@if (statusItem().icon) {
			<div class="status-item-icon">
				<i class="fa-sharp fas" [ngClass]="'fa-'+statusItem().icon"></i>
			</div>
		}
		<div class="status-item-val">{{statusItem().text}}</div>
	</div>
</div>